export default "__VITE_ASSET__D2xQk00n__"